<template lang="pug">
div
  div.form-check.mb-3
    input#limited_time.form-check-input(type='checkbox', name='limited_time', @click='setLimitedTime', :checked="scope.limited_time", value=1)
    div.d-flex.align-items-center.mb-3
      label.form-check-label(for='limited_time') 表示開始・終了予約をする
      span.upper-master-label.ml-2 Master以上
      UpgradeUpperMaster(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
  div.form-group(v-if="scope.limited_time")
    .row.pl-4
      .col-12
        div.form-group
          div.d-flex
            .col-5
              .input-group
                input#limited_time_from.form-control(
                  type='datetime-local',
                  name='limited_time_from',
                  @input='setLimitedTimeFrom',
                  :value="scope.limited_time_from",
                  :class="{ 'is-invalid': scope.limited_time && !scope.limited_time_from }"
                )
                .invalid-feedback(v-if="scope.limited_time && !scope.limited_time_from") 開始日時を入力してください
            p.text-muted.mt-1 〜
            .col-5
              .input-group
                input#limited_time_to.form-control(
                  type='datetime-local',
                  name='limited_time_to',
                  @input='setLimitedTimeTo',
                  :value="scope.limited_time_to",
                  :class="{ 'is-invalid': scope.limited_time && !scope.limited_time_to || scope.limited_time && scope.limited_time_from && scope.limited_time_to && new Date(scope.limited_time_from) > new Date(scope.limited_time_to) }"
                )
                .invalid-feedback(v-if="scope.limited_time && !scope.limited_time_to") 終了日時を入力してください
                .invalid-feedback(v-if="scope.limited_time && scope.limited_time_from && scope.limited_time_to && new Date(scope.limited_time_from) > new Date(scope.limited_time_to)") 終了日時は開始日時より後にしてください
            p.text-muted.mt-1 表示
</template>

<script>
//libs
import UpgradeUpperMaster from "../modals/upgrade_upper_master.vue";

export default {
  props: {
    show_with_parameters: { type: Boolean, default: false },
  },
  methods: {
    setLimitedTime(e){
      if (!this.show_with_parameters) {
        this.isDisplayModal(e);
      } else {
        this.$store.commit("creative/setLimitedTime", e.target.checked)
      }
    },
  },
  data(){
    return {
      is_upgrade_upper_master_modal: false,
    }
  },
  methods: {
    isDisplayModal(e) {
      this.is_upgrade_upper_master_modal = true;
      e.preventDefault();
    },
    setLimitedTime(e){
      if(this.show_with_parameters){
        this.$store.commit("creative/setLimitedTime", e.target.checked)
      } else {
        e.preventDefault();
        this.is_upgrade_upper_master_modal = true
      }
    },
    setLimitedTimeFrom(e){
      this.$store.commit("creative/setLimitedTimeFrom", e.target.value)
    },
    setLimitedTimeTo(e){
      this.$store.commit("creative/setLimitedTimeTo", e.target.value);
    },
  },
  components: {
    UpgradeUpperMaster,
  },
  computed: {
    scope() {
      return {
        limited_time: this.$store.state.creative.preview_list.limited_time,
        limited_time_from: this.$store.state.creative.preview_list.limited_time_from,
        limited_time_to: this.$store.state.creative.preview_list.limited_time_to,
      }
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
